// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1mAzw","container":"styles_container__ujABo","title":"styles_title__m1yUl","wrapper":"styles_wrapper__yk8kP","answer":"styles_answer__1xRHh"};